import { YStack, XStack, Text, View, useMedia } from 'tamagui'
import { CoverImage } from '@components/CoverImage'
import { useTranslation } from 'react-i18next'
import TeacherGraphicSvg from '@assets/product/teacher_graphic_detail.svg'
import { IProductPage } from '@dtos/ProductPage'
import { SectionTitle } from './SectionTitle'
import { HtmlContent } from './HtmlContent'

// Sobre o instrutor (productPage_teacher): grafismo de pontos sobre o canto
// superior esquerdo da foto e "sobre" renderizado como HTML (o cliente pode
// customizar com blockquote, negrito etc., como no hero_theme).
export function TeacherSection({ product }: { product: IProductPage }) {
  const { t } = useTranslation('ProductPage')
  const media = useMedia()
  const teacher = product.teachers[0]

  if (!teacher) return null

  return (
    <YStack width="100%" marginTop={64} testID="product-teacher">
      <SectionTitle>{t('teacher.title')}</SectionTitle>
      <XStack
        gap={48}
        alignItems={media.gtSm ? 'center' : 'flex-start'}
        flexDirection={media.gtSm ? 'row' : 'column'}
      >
        {teacher.photoUrl ? (
          <View
            position="relative"
            marginTop={16}
            width={media.gtSm ? undefined : '100%'}
          >
            <View position="absolute" top={-16} left={16} zIndex={1}>
              <TeacherGraphicSvg width={60} height={56} />
            </View>
            <CoverImage
              uri={teacher.photoUrl}
              alt={teacher.fullName ?? ''}
              width={media.gtSm ? 315 : '100%'}
              height={media.gtSm ? 315 : 240}
              borderRadius={4}
            />
          </View>
        ) : null}
        <YStack flex={1} gap={24}>
          <Text
            color="$text-primary"
            fontSize={20}
            fontFamily="$mulishSemiBold"
            fontWeight="600"
          >
            {teacher.fullName}
          </Text>
          {teacher.about ? <HtmlContent html={teacher.about} /> : null}
        </YStack>
      </XStack>
    </YStack>
  )
}
